import { EATS_NAV } from '../config/nav';

/**
 * Which nav tab a path belongs to.
 *
 * `/eats` matches exactly — every other Eats path starts with it; the rest match
 * by prefix. A branch is edited in a modal over `/eats/branches` rather than on
 * a screen of its own, so the Venues tab has no second path to own.
 *
 * Shared by both shells so the two chromes can never disagree about which tab
 * is lit.
 */
export function isEatsNavActive(navPath: string, pathname: string): boolean {
  if (navPath === '/eats') return pathname === '/eats';
  return pathname.startsWith(navPath);
}

/** What the mobile nav bar names the current screen. */
export interface EatsScreen {
  /** i18n key (`eats` namespace) for the large title. */
  titleKey: string;
  /** i18n key for the muted line beneath it. */
  subtitleKey: string;
}

/**
 * The mobile nav bar titles the SUB-APP and subtitles the SECTION — "Еда" over
 * "Дашборд" — rather than titling the section itself. The desktop chrome says
 * which sub-app you are in with a wordmark and which section with a lit tab;
 * mobile has neither, so the nav bar carries both facts.
 *
 * Falls back to the dashboard's subtitle for a path no tab owns (`/profile`,
 * `/support`), which keeps the bar titled rather than blank.
 */
export function eatsScreenForPath(pathname: string): EatsScreen {
  const match = EATS_NAV.find((item) => isEatsNavActive(item.path, pathname));
  return {
    titleKey: 'nav.subAppTitle',
    subtitleKey: match ? match.labelKey : 'nav.dashboard',
  };
}
